<template>
  <div>
    <h1 class="section-title text-center text-4xl sm:text-5xl my-2 mt-16 xl:mt-32 py-2 px-4 mb-12 xl:mb-24 pt-16 underline">
      My Experience
    </h1>

    <div class="w-full px-4 sm:px-6 lg:px-10">
      <div class="grid grid-cols-1 xl:grid-cols-3 gap-8 max-w-7xl mx-auto items-stretch">

        <!-- Languages Container -->
        <div class="w-full border rounded bg-neutral-900 px-5 sm:px-8 py-10 min-h-[420px] flex flex-col">
          <h1 class="text-center text-2xl mb-8">Languages</h1>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-base sm:text-xl lg:text-2xl flex-1 content-center">
            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" />
              <p class="pl-3">HTML</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/css3/css3-original-wordmark.svg" />
              <p class="pl-3">CSS</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" />
              <p class="pl-3">JavaScript</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" />
              <p class="pl-3">Python</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg" />
              <p class="pl-3">C</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" />
              <p class="pl-3">TypeScript</p>
            </div>
          </div>
        </div>

        <!-- Frontend Container -->
        <div class="w-full border rounded bg-neutral-900 px-5 sm:px-8 py-10 min-h-[420px] flex flex-col">
          <h1 class="text-center text-2xl mb-8">Frontend</h1>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-base sm:text-xl lg:text-2xl flex-1 content-center">
            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" />
              <p class="pl-3">React</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg" />
              <p class="pl-3">Vue</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg" />
              <p class="pl-3">Bootstrap</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg" />
              <p class="pl-3">Tailwind</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vitejs/vitejs-original.svg" />
              <p class="pl-3">Vite</p>
            </div>
          </div>
        </div>

        <!-- Backend Container -->
        <div class="w-full border rounded bg-neutral-900 px-5 sm:px-8 py-10 min-h-[420px] flex flex-col">
          <h1 class="text-center text-2xl mb-8">Backend</h1>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 text-base sm:text-xl lg:text-2xl flex-1 content-center">
            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" />
              <p class="pl-3">Node</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sequelize/sequelize-original.svg" />
              <p class="pl-3">Sequelize</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" />
              <p class="pl-3">MongoDB</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="white-logo devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" />
              <p class="pl-3">Express</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" />
              <p class="pl-3">PostgreSQL</p>
            </div>

            <div class="flex items-center justify-start py-4 px-4">
              <img class="white-logo devicon-devicon-plain" src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flask/flask-original.svg" />
              <p class="pl-3">Flask</p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyExperience'
}
</script>